import axios from 'axios'
import { BACKEND_DOMAIN } from '../../common/env';

export const fetchTeamDetails = async (auctionId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${BACKEND_DOMAIN}/auctions/${auctionId}/teams`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.teams || [];
    } catch (error) {
      console.error("Error fetching teams:", error);
      throw error;
    }
};